import z from "zod";

import {
  AgeRangeEnumType,
  ApplicationLastStepEnumType,
  ApplicationStatusEnumType,
  ApplicationTypeEnumType,
  AuditTrailAuthEventType,
  AuditTrailDownloadEventRecordType,
  ChildCaregiverStatusEnumType,
  CitizenshipStatusEnumType,
  ConsentTypeEnumType,
  CoverageStatusEnumType,
  DocumentGroupEnumType,
  DocumentTypeEnumType,
  EligibilityCategoryType,
  EmploymentStatusEnumType,
  FederalGroupEnumType,
  HealthInsuranceOrCoverageStatusEnumType,
  MaritalStatusEnumType,
  MedicalExpenses3MonthsHelpNeededStatusEnumType,
  PayFrequencyEnumType,
  RelationshipEnumType,
  TaxClaimedAsDependentStatusEnumType,
  TaxDependentsClaimedStatusEnumType,
  TaxFilingStatusEnumType,
  TaxRelationshipEnumType,
  UnemploymentCompensationStatusEnumType,
  UsStatesEnumType,
} from "@libs/db-schemas";
import { ShortCodeContext } from "@libs/kubb";

import {
  applicationApplicantSchema,
  coverageCheckServiceTypeSchema,
  coverageDetailsSchema,
  householdMemberDocumentRequirementsSchema,
  householdMemberDocumentRequirementsSectionSchema,
  householdMemberWithCoverageSchema,
  memberCoverageSchema,
} from "./schemas";

export type {
  ApplicationStatusEnumType,
  ApplicationTypeEnumType,
  ApplicationLastStepEnumType,
  UsStatesEnumType,
  CoverageStatusEnumType,
  DocumentGroupEnumType,
  DocumentTypeEnumType,
  RelationshipEnumType,
  MaritalStatusEnumType,
  TaxFilingStatusEnumType,
  TaxDependentsClaimedStatusEnumType,
  TaxClaimedAsDependentStatusEnumType,
  TaxRelationshipEnumType,
  EmploymentStatusEnumType,
  UnemploymentCompensationStatusEnumType,
  PayFrequencyEnumType,
  MedicalExpenses3MonthsHelpNeededStatusEnumType,
  CitizenshipStatusEnumType,
  HealthInsuranceOrCoverageStatusEnumType,
  ChildCaregiverStatusEnumType,
  AgeRangeEnumType,
  FederalGroupEnumType,
  EligibilityCategoryType,
  AuditTrailAuthEventType,
  ShortCodeContext as ShortCodeContextType,
  AuditTrailDownloadEventRecordType,
  ConsentTypeEnumType,
};

export type CoverageCheckServiceTypeType = z.infer<
  typeof coverageCheckServiceTypeSchema
>;
export type CoverageDetailsType = z.infer<typeof coverageDetailsSchema>;
export type MemberCoverageType = z.infer<typeof memberCoverageSchema>;
export type HouseholdMemberWithCoverageType = z.infer<
  typeof householdMemberWithCoverageSchema
>;

export type HouseholdMemberDocumentRequirementsType = z.infer<
  typeof householdMemberDocumentRequirementsSchema
>;
export type HouseholdMemberDocumentRequirementsSectionType = z.infer<
  typeof householdMemberDocumentRequirementsSectionSchema
>;

export type ApplicationApplicantType = z.infer<
  typeof applicationApplicantSchema
>;
